import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Button } from '@r1-frontend/ui-kit/atoms/button';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

interface IMenuButtonProps {
    children: ReactNode,
    onClick?: () => void,
    className?: string,
}

export const MenuButton = styled(({ children, onClick, className }: IMenuButtonProps) => (
    <Button $small $type={'ghost'} onClick={onClick} className={className}>
        {children}
    </Button>
))`
    ${({ theme }: ThemedProperties) => css`
        padding: ${theme.indents.xxxxxs}px ${theme.indents.xxs}px;

        & > span {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: ${theme.indents.xxxxs}px;

            svg {
                stroke: ${theme.colors.text.head};
            }
        }

        @media (max-width: ${theme.breakpoints.mobile}) {
            padding: ${theme.indents.xxs}px;
        }
    `};
`;
